import Axios from 'axios';
import store from '@/store';

const axios = Axios.create();
axios.interceptors.response.use(function(response) {
  return response;
}, function (error) {
  switch (error.response?.status) {
    case 401:
    case 419:
      store.dispatch('auth/sessionExpire');
      break;
    case 403:
      store.dispatch('auth/forbiddenAccess',error.response);
      break;
    case 400:
    case 500:
      return error.response;
    default:
      console.log(error);
  }
});

export default axios;